import { render, staticRenderFns } from "./entries-container.vue?vue&type=template&id=3fef91e3"
import script from "./entries-container.vue?vue&type=script&lang=js"
export * from "./entries-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports